<template>
  <VPopup
    :target="target"
    :visible="true"
    show-pointer
    position="left"
    padding="10px"
    :css-classes="['price-mod-popup']"
  >
    <dl>
      <dt>Наценка платформы</dt>
      <dd>{{ orderOption.priceMod }}</dd>
    </dl>

    <dl>
      <dt>Кредитная наценка</dt>
      <dd>{{ orderOption.priceModDeferredPayment }}</dd>
    </dl>

    <dl>
      <dt>Итого:</dt>
      <dd>{{ orderOption.priceModTotal }}</dd>
    </dl>
  </VPopup>
</template>

<style src="./PriceModPopup.scss" />

<script lang="ts">
import type AbstractOrderOption from '@/domains/Abstract/AbstractOrderOption';

export default defineComponent({
  name: 'PriceModPopup',

  props: {
    /** Ставка или опция потребности — из неё берутся все наценки. */
    orderOption: {
      type:     Object as PropType<AbstractOrderOption>,
      required: true,
    },

    /** Элемент, у которого рисуется попап. */
    target: {
      type:    HTMLElement,
      default: null,
    },
  },
});
</script>
